import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {DialogService} from "../../../../../../services/core/dialog.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BackendApiService} from "../../../../../../services/backend-api.service";
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {ProductDataService} from "../../../../../inventory/product/product.data.service";
import {MeasurementUnitDataService} from "../../../../../inventory/measurement-unit/measurement-unit.data.service";
import {ScopeDataService} from "../../../../../setting/scope/scope.data.service";
import {ToasterService} from "../../../../../../services/core/toaster.service";
import {HelperService} from "../../../../../../services/helper.service";
import {
  CreateEditVendorComponent
} from "../../../../../inventory/vendor/create-edit-vendor/create-edit-vendor.component";
import {
  AddManufacturerComponent
} from "../../../../../inventory/product/product-create/add-manufacturer/add-manufacturer.component";
import {
  AddUnitOfMeasurementComponent
} from "../../../../../inventory/product/product-create/add-unit-of-measurement/add-unit-of-measurement.component";
import {ServiceService} from "../../../../../inventory/service/service.service";
import {
  CreateEditSubcontractorComponent
} from "../../../../../inventory/subcontractor/create-edit-subcontractor/create-edit-subcontractor.component";
import {QuickVendorComponent} from "../create-proposal-scope-product/quick-vendor/quick-vendor.component";
import {QuickSubcontractorComponent} from "./quick-subcontractor/quick-subcontractor.component";
import {CurrencyMaskOptions} from "../../../../../shared/shared.constants";

@Component({
    selector: 'app-create-proposal-scope-service',
    templateUrl: './create-proposal-scope-service.component.html',
    styleUrls: ['./create-proposal-scope-service.component.scss'],
    standalone: false
})
export class CreateProposalScopeServiceComponent implements OnInit {
  public currencyMaskOptions = CurrencyMaskOptions;
  vendors:any=[];
  public productTypes : any = [];
  public manufacturers: any = [];
  public measurementUnits: any = [];
  public scopes: any=  [];
  scopeObject:any =[];
  ngSelectReadOnly :boolean = false;
  public proposalScopeServiceForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null,[Validators.required]),
    serviceType: new UntypedFormControl(null,[Validators.required]),
    // productUrl: new UntypedFormControl(null,[Validators.pattern('(https?://)?([\\da-zA-Z.-]+)\\.([a-zA-Z.]{2,6})[/\\w .-]*/?')]),
    scopes:new UntypedFormControl([],[Validators.required]),
    subcontractor:new UntypedFormControl(null,[Validators.required]),
    mark_up: new UntypedFormControl(null,[Validators.required]),
    unitPrice: new UntypedFormControl(null,[Validators.required]),
    description: new UntypedFormControl(null,[]),
  })

  constructor(
    public dialogService: DialogService,
    public dialogRef: MatDialogRef<CreateProposalScopeServiceComponent>,
    public backendApiService:BackendApiService,
    public dialog: NgDialogAnimationService,
    public productDataService: ProductDataService,
    public  measurementUnitDataService:MeasurementUnitDataService,
    public scopeDataService: ScopeDataService,
    public toasterService: ToasterService,
    public helperService: HelperService,
    public serviceService: ServiceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    console.log('dataaa',this.data);
  }


  ngOnInit(): void {
    // this.getVendors();
    this.initDropDownData();
    this.serviceService.getSubcontractors();
    this.serviceService.getServiceType();

    this.proposalScopeServiceForm.get('name')?.setValue(this.data?.name);
    this.proposalScopeServiceForm.get('scopes')?.setValue([this.data?.scope_id]);
    if(this.data.type == 4) {
      this.ngSelectReadOnly = true;
      this.proposalScopeServiceForm.get('serviceType')?.setValue({id:3,name:'Shipping/Freight Service'});
    } else if  (this.data.type == 3) {
      this.ngSelectReadOnly = true;
      this.proposalScopeServiceForm.get('serviceType')?.setValue({id:2,name:'Labor Service'});
    } else if (this.data?.type == 2) {
      this.ngSelectReadOnly = true;
      this.proposalScopeServiceForm.get('serviceType')?.setValue({id:1,name:'Other Service'});

    }
  }


  getFormData = () => {
    const formValue = this.proposalScopeServiceForm.value
    return {
      name:formValue.name,
      scopes:formValue.scopes,
      type:formValue.serviceType.id,
      subcontractor: formValue.subcontractor.id,
      unit_price: formValue.unitPrice,
      mark_up: formValue.mark_up,
      productStatus: formValue.productStatus,
      description: formValue.description,
    }
  }

  createSubcontractor(e: any): void {
    e.preventDefault();
    this.dialogService.onOpenDialog(CreateEditSubcontractorComponent);
    this.dialogService.afterClose()?.subscribe((result: any) => {
      console.log('result', result);
    });
  }
  createQuickSubcontractor(): void {
    const dialogRef = this.dialog.open(QuickSubcontractorComponent, {
      // disableClose: true,
      width: '500px',
      maxWidth: '500px',
      maxHeight: '80vh',
      panelClass: 'quick-subcontractor-dialog-container',
    });
    dialogRef?.afterClosed()?.subscribe((result: any) => {
      if(result){
        console.log('result',result);
        this.proposalScopeServiceForm?.get('subcontractor')?.setValue({id:result?.id,name:result?.name})
      }
    });
  }
  getVendors = () =>{
    this.backendApiService.postApi('vendors','')
      .subscribe((result:any) => {
        this.vendors = result.data;
      })
  }
  initDropDownData(){
    // this.serviceService.getScopes();
    /*this.productDataService.getTypes()
      .subscribe((response: any) => {
        this.productTypes = response.data;
      });
    this.initManufacturers();
    this.initUnitOfMeasurement();*/
    this.scopesList();
  }
  initManufacturers(){
    this.productDataService.getManufacturers()
      .subscribe((response: any) => {
        this.manufacturers = response.data;
      });
  }
  initUnitOfMeasurement(){
    this.measurementUnitDataService.list()
      .subscribe((response: any) => {
        this.measurementUnits = response.data;
      });
  }
  scopesList(){
    this.scopeDataService.userSelectedScopesList()
      .subscribe((response: any) => {
        this.scopes = response.data;
      });
  }
  save = () => {
    this.touchFormControls();
    if(this.proposalScopeServiceForm.invalid){
      this.toasterService.showWarning('Please fill required fields');
      return;
    }
    this.backendApiService.postApi('services/create', this.getFormData())
      .subscribe((response: any)=>{
        console.log('response',response);
        this.toasterService.showSuccessMessage(response.data.message);
        this.close(response.data.service);
      })


  }

  touchFormControls(){
    Object.keys(this.proposalScopeServiceForm.controls).forEach(key => {
      console.log('key', key);
      this.proposalScopeServiceForm.get(key)?.markAsTouched();
    });
  }
  removeHttp(){
    const url = this.helperService.removeHttp(this.proposalScopeServiceForm.get('productUrl')?.value);
    this.proposalScopeServiceForm.get('productUrl')?.setValue(url);
  }


  close = (data: any = null) => {
    this.dialogRef.close(data);
  }

    protected readonly CurrencyMaskOptions = CurrencyMaskOptions;
}

